import {
  Box,
  BoxProps,
  CheckBox,
  Form,
  IconButton,
  ModalDialog,
  RadioButton,
  SpacerNew,
  TextNew,
  TextNewProps,
} from '@jfs/ui-new'
import { TextInputNew } from '../../../../../components/AdminInputs'
import { ButtonNew } from '../../../../../components/AdminButton'
import { useState } from 'react'
import { FlatList } from 'react-native'
import { DropdownOptimised } from '../../../../../components/DropdownNew'
import { FormContainer } from '../../EntityOnboardingForm'

interface FiltersModalProps {
  show: boolean
  onDismiss: any
  data: any[]
  onApplyFiter: any
  onReset: any
  initialValue: any
  entityList?: any
}

export const FiltersModal = ({ show, onDismiss, data, onApplyFiter, onReset, initialValue }: FiltersModalProps) => {
  const renderActionButton = ({ values, resetForm }) => {
    return (
      <Box
        borderTopWidth={1}
        borderColor={'BORDER_COLOR'}
        pv={16}
        ph={24}
        flexDirection={'row'}
        justifyContent={'flex-end'}>
        <ButtonNew
          title={'Reset'}
          type={'secondary'}
          width={148}
          borderColor={'PRIMARY'}
          onPress={() => {
            //resetForm()
            onReset({})
            onDismiss()
          }}
        />
        <SpacerNew direction="horizontal" size={24} />
        <ButtonNew
          title={'Apply Filters'}
          type={'primary'}
          width={148}
          onPress={() => {
            onApplyFiter(values)
            onDismiss()
          }}
        />
      </Box>
    )
  }

  return (
    <ModalDialog show={show} onDismiss={onDismiss} type="Right">
      <Box {...styles.filterModelContainer}>
        <Box {...styles.filterModelHeader}>
          <TextNew fontSize={18} fontFamily="jiotype-bold" color={'BLACK_21'} title="Filters" />
          <IconButton onPress={onDismiss} id="CLOSE" color="PRIMARY" size={24} />
        </Box>
        <Box f={1} ph={16}>
          <Form
            formData={getFilterModalFormData(data)}
            actionButtons={renderActionButton}
            initialValues={initialValue}
            container={FormContainer}
          />
        </Box>
      </Box>
    </ModalDialog>
  )
}

const getFilterModalFormData = (data): any => {
  return [
    {
      key: 'FILTER_ITEM_FORM',
      verticalFlex: 1,
      contentOverflow: 'auto',
      contentPadding: 0,
      horizontalFlex: 1,
      title: 'Business Contact',
      formItems: [
        ...data?.map(({ labelKey, labelDescription, checkBoxItems, ...props }) => {
          return {
            fieldName: labelKey,
            ComponentName: FilterItem,
            headerTitle: labelDescription,
            checkBoxItems: checkBoxItems,
            ...props,
          }
        }),
      ],
      onSubmit: async (values) => {},
    },
  ]
}

const FilterItem = (props) => {
  console.log('darshan props =', props)
  const [isSelectedAllChecked, setIsSelectedAllChecked] = useState(
    props?.allValues?.[props?.fieldName]?.length === props?.checkBoxItems?.length,
  )

  const onSelectDeselectAll = () => {
    setIsSelectedAllChecked(!isSelectedAllChecked)
    if (!isSelectedAllChecked) {
      props?.setFieldValue(
        props?.fieldName,
        props?.checkBoxItems?.map((item) => ({
          ...item,
          isChecked: true,
        })),
      )
    } else {
      props?.setFieldValue(props?.fieldName, [])
    }
  }

  const onCheckChange = (isChecked, item) => {
    console.log('htag isChecked', isChecked)
    console.log('htag typeof isChecked', typeof isChecked)
    console.log('htag item ', item)
    console.log('htag (props?.allValues?.[', props?.allValues?.[props?.fieldName] ?? [])
    if (props?.singleSelection) {
      const selectedData = (props?.allValues?.[props?.fieldName] ?? [item])?.map((data) => ({
        ...data,
        isChecked: data.key === item?.key ? true : false,
      }))

      console.log('htag selectedData=', selectedData)
      props?.setFieldValue(props?.fieldName, [{ ...item, isChecked: true }])
    } else {
      const selectedData = (props?.allValues?.[props?.fieldName] ?? [])
        ?.filter((data) => data.key !== item?.key)
        .concat(isChecked == 'true' ? { ...item, isChecked: true } : [])

      setIsSelectedAllChecked(selectedData?.length === props?.checkBoxItems?.length)
      console.log('htag  selectedData', selectedData)
      props?.setFieldValue(props?.fieldName, selectedData)
    }
  }

  const renderItem = ({ item }) => (
    <Box f={1} pb={64}>
      {!props?.singleSelection && (
        <CheckBox
          iconSize={16}
          textLabel={item?.description}
          fontSize={12}
          textColor="BLACK_75"
          onChange={(isChecked) => onCheckChange(isChecked, item)}
          checked={props?.allValues?.[props?.fieldName]?.find((data) => data.key === item?.key)?.isChecked}
        />
      )}
      {props?.singleSelection && (
        <RadioButton
          textLabel={item?.description}
          hoverColor={'TRANSPARENT'}
          textSize={12}
          fontFamily="jioType-light"
          textColor="BLACK_75"
          fontWeight="BOLD"
          onChange={(isChecked) => onCheckChange(isChecked, item)}
          checked={props?.allValues?.[props?.fieldName]?.find((data) => data.key === item?.key)?.isChecked}
        />
      )}
    </Box>
  )
  return (
    <Box flexDirection={'column'} ml={16}>
      <Box flexDirection={'row'}>
        <TextNew {...styles.filterModelLabelText}>{props?.headerTitle}</TextNew>
        <SpacerNew direction="horizontal" size={24} />
        {!props?.singleSelection && (
          <CheckBox
            iconSize={16}
            textLabel={'Select All'}
            fontSize={14}
            textColor="BLACK_75"
            fontWeight="FONT_WEIGHT_BOLD"
            onChange={onSelectDeselectAll}
            checked={isSelectedAllChecked}
          />
        )}
      </Box>
      <SpacerNew size={24} />
      {props?.componentType === 'dropdown' && <FilterDropdown {...props} />}
      {!props?.componentType && (
        <FlatList data={props?.checkBoxItems} renderItem={renderItem} keyExtractor={(item) => item.id} numColumns={3} />
      )}
      {props?.componentType === 'inputText' && <TextInputNew {...props} />}
    </Box>
  )
}

const FilterDropdown = (props: any) => {
  return <DropdownOptimised {...props} />
}

const styles = {
  filterModelContainer: {
    width: '40vw',
    height: '100vh',
    backgroundColor: 'WHITE',
  } as BoxProps,
  filterModelHeader: {
    pv: 16,
    ph: 24,
    borderBottomWidth: 1,
    borderBottomColor: 'BORDER_COLOR',
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  filterModelLabelText: {
    fontSize: 14,
    fontFamily: 'jioType-bold',
    color: 'BLACK_21',
  } as TextNewProps,
}
